const COLOR_LIST = [
  { id: 1, text: 'white' },
  { id: 2, text: 'black' },
  { id: 3, text: 'grey' },
  { id: 4, text: 'green' },
  { id: 5, text: 'yellow' },
  { id: 6, text: 'red' },
  { id: 7, text: 'blue' },
];

export default COLOR_LIST;
